import React from 'react';
// components
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
// assets
import editBtn from 'img/edit-icon-table.svg';
import newBtn from 'img/icon-new-mapping.svg';
import newBtnDisabled from 'img/icon-new-mapping-disabled.svg';
// interfaces
import { QuoteActionProps } from './interface';
// styles
import './styles.scss';
import { Button } from 'components/Button';
import { colors } from '../../styles/colors';

const QuoteActionButton = ({
  id,
  item,
  quoteId,
  onClick,
  isValid,
  tooltip,
  sequence,
  quoteCode,
  isCustomer,
  isQuoteExpired,
  sequenceNumber,
  productPortfolio
}: QuoteActionProps) => (
  <>
    <Visibility visible={id == null && !isQuoteExpired}>
      <Button
        tooltip={!productPortfolio && tooltip ? tooltip : ""}
        role="buttonModalDePara"
        data-code={`data-code-${quoteCode}${sequenceNumber}`}
        onClick={() => productPortfolio && onClick(quoteId, sequenceNumber, sequence)}
        className={
          !productPortfolio
            ? `text-center display-align create-disabled ${sequenceNumber}`
            : `text-center display-align ${sequenceNumber}`
        }
      >
        <>
          <img src={!productPortfolio ? newBtnDisabled : newBtn} alt="criar Depara" />
          <Text className="mt-1" size={6} color={!productPortfolio ? colors.vpcGray : colors.greenDarkViveo}>
            CRIAR DE/PARA
          </Text>
        </>
      </Button>
    </Visibility>

    <Visibility visible={id != null && isCustomer === false && isValid && item.itemStock}>
      <Button
        role='buttonModalDePara'
        data-code={`data-code-${quoteCode}${sequenceNumber}`}
        onClick={() => onClick(quoteId, sequenceNumber, sequence)}
        className={`flex-1 text-center display-align ${sequenceNumber}`}
      >
        <img src={editBtn} alt="Editar" className='btnEdit' />
      </Button>
    </Visibility>
  </>
);

export default QuoteActionButton;
